'use strict';

DoohApps.filter('windowStartStyle', function () {
    return function (value) {
        switch (parseInt(value)) {
            case 0:
                return 'Normal';
            case 1:
                return 'Hidden';
            case 2:
                return 'Minimized';
            case 3:
                return 'Maximized';
            default:
                return 'Not set';
        }
    }
});